<div class="containerTest">
  <div class="text-center">
      <h1>RentWise Evaluations under Agency: {{ agency?.agencyName }}</h1>
  </div>
  <hr>
  <div class="card">
      <div class="card-body" style="overflow-x:auto;" *ngIf="preTest && postTest">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
              <thead>
                  <tr>
                      <th>First Name</th>
                      <th>Middle Initial</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Age Under 18</th>

                      <th>Evaluation Completed</th>
                      <th>Completion Date</th>

                      <!-- Question 1 -->
                      <th class="th-question many-questions">PreEval Q1: {{ preTest.questions[0].question }}</th>
                      <th class="th-question many-questions">PostEval Q1: {{ postTest.questions[0].question }}</th>
                      <th class="th-question score">PreEval Q1: Sum Score</th>
                      <th class="th-question score">PostEval Q1: Sum Score</th>
                      <th class="th-question score">PostEval Q1: Sum Score Change</th>
                      <th class="th-question score">PreEval Q1: Avg Score</th>
                      <th class="th-question score">PostEval Q1: Avg Score</th>
                      <th class="th-question score">PostEval Q1: Avg Score Change</th>
                      <th *ngFor="let rawcol of ui.rawData(0).columns" class="th-question raw"><span [innerHtml]="rawcol | multiline"></span></th>

                      <!-- Question 2 -->
                      <th class="th-question many-questions">PreEval Q2: {{ preTest.questions[1].question }}</th>
                      <th class="th-question many-questions">PostEval Q2: {{ postTest.questions[1].question }}</th>
                      <th class="th-question score">PreEval Q2: Sum Score</th>
                      <th class="th-question score">PostEval Q2: Sum Score</th>
                      <th class="th-question score">PostEval Q2: Sum Score Change</th>
                      <th class="th-question score">PreEval Q2: Avg Score</th>
                      <th class="th-question score">PostEval Q2: Avg Score</th>
                      <th class="th-question score">PostEval Q2: Avg Score Change</th>
                      <th *ngFor="let rawcol of ui.rawData(1).columns" class="th-question raw"><span [innerHtml]="rawcol | multiline"></span></th>

                      <!-- Question 3 -->
                      <th class="th-question">PreEval Q3: {{ preTest.questions[2].question }}</th>
                      <th class="th-question">PostEval Q3: {{ postTest.questions[2].question }}</th>

                      <!-- Question 4 -->
                      <th class="th-question">PreEval Q4: {{ preTest.questions[3].question }}</th>
                      <th class="th-question">PostEval Q4: {{ postTest.questions[3].question }}</th>

                      <!-- Question 5 -->
                      <th class="th-question">PostEval Q5: {{ postTest.questions[4].question }}</th>

                      <!-- Question 6 -->
                      <th class="th-question">PostEval Q6: {{ postTest.questions[5].question }}</th>

                      <th>Street Address 1</th>
                      <th>Street Address 2</th>
                      <th>City</th>
                      <th>State</th>
                      <th>Zip Code</th>
                      <th>County</th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let e of evaluations; index as i">
                      <td>{{ e.user?.firstName }}</td>
                      <td>{{ e.user?.middleInitial }}</td>
                      <td>{{ e.user?.lastName }}</td>
                      <td>{{ e.user?.email }}</td>
                      <td>{{ e.user?.phone }}</td>
                      <td>{{ e.user?.ageUnder18 | boolean:'Yes':'No' }}</td>

                      <td>{{ e.isCompleted | boolean:'Yes':'No' }}</td>
                      <td [attr.data-sort]="sortDate(e.completionDate)">{{ (e.completionDate | date) || 'N/A' }}</td>

                      <td class="td-answer many-questions">
                        <app-comments-list [question]="ui.qtable(e.preTest, 0)"></app-comments-list>
                      </td>
                      <td class="td-answer many-questions">
                        <app-comments-list [question]="ui.qtable(e.postTest, 0)"></app-comments-list>
                      </td>
                      <td>{{ scores[i][0]?.before?.sum }}</td>
                      <td>{{ scores[i][0]?.after?.sum }}</td>
                      <td>{{ scores[i][0]?.change?.sum | signedNumber }}</td>
                      <td>{{ scores[i][0]?.before?.avg | number:'1.1-2' }}</td>
                      <td>{{ scores[i][0]?.after?.avg | number:'1.1-2' }}</td>
                      <td>{{ scores[i][0]?.change?.avg | number:'1.1-2' | signedNumber }}</td>
                      <td *ngFor="let rawdata of ui.rawData(0).data[i]" class="td-answer raw">{{rawdata}}</td>

                      <td class="td-answer many-questions">
                        <app-comments-list [question]="ui.qtable(e.preTest, 1)"></app-comments-list>
                      </td>
                      <td class="td-answer many-questions">
                        <app-comments-list [question]="ui.qtable(e.postTest, 1)"></app-comments-list>
                      </td>
                      <td>{{ scores[i][1]?.before?.sum }}</td>
                      <td>{{ scores[i][1]?.after?.sum }}</td>
                      <td>{{ scores[i][1]?.change?.sum | signedNumber }}</td>
                      <td>{{ scores[i][1]?.before?.avg | number:'1.1-2' }}</td>
                      <td>{{ scores[i][1]?.after?.avg | number:'1.1-2' }}</td>
                      <td>{{ scores[i][1]?.change?.avg | number:'1.1-2' | signedNumber }}</td>
                      <td *ngFor="let rawdata of ui.rawData(1).data[i]" class="td-answer raw">{{rawdata}}</td>

                      <td class="td-answer">{{ ui.qtext(e.preTest, 2)?.answer?.text }}</td>
                      <td class="td-answer">{{ ui.qtext(e.postTest, 2)?.answer?.text }}</td>

                      <td class="td-answer">{{ ui.qtext(e.preTest, 3)?.answer?.text }}</td>
                      <td class="td-answer">{{ ui.qtext(e.postTest, 3)?.answer?.text }}</td>

                      <td class="td-answer">{{ ui.qtext(e.postTest, 4)?.answer?.text }}</td>

                      <td class="td-answer">{{ ui.qtext(e.postTest, 5)?.answer?.text }}</td>

                      <td>{{ e.user?.streetAddress }}</td>
                      <td>{{ e.user?.secondary }}</td>
                      <td>{{ e.user?.city }}</td>
                      <td>{{ e.user?.state }}</td>
                      <td>{{ e.user?.zipCode }}</td>
                      <td>{{ e.user?.county }}</td>
                  </tr>
              </tbody>
          </table>
      </div>
  </div>
</div>
